<template>
<div v-if="shouldAsk">
  <hr class="paymentDividor">

  <div id="OptinRewards">
    <h3>
      Would you like to earn rewards on this order?
    </h3>

    <v-radio-group v-model="optOutRewards">
      <v-radio
        label="Yes, I want the rewards."
        :value="false"
      />

      <v-radio
        label="No, thanks"
        :value="true"
      />
    </v-radio-group>
  </div>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import get from 'lodash/get';


export default {

  computed: {
    shouldAsk() {
      // Flag that enables this component. 
      // When true, we only provide rewards when they request
      const payWithMembership = this.getPaymentType && this.getPaymentType.length && this.getPaymentType[0] === 'membership'
      return this.getStore.settings.rewardsSettings.requireOptIn && (!this.getStore.features.membershipPayNoRewards || !payWithMembership)
    },

    optOutRewards: {
      get() {
        return get(this.getCheckoutInfo, 'optOutRewards', false)
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          optOutRewards: value
        })
      }
    },

    ...mapGetters([ 'getStore', 'getCheckoutInfo', 'getPaymentType' ])
  },

  methods: {

    ...mapMutations([ 'SET_CHECKOUT_INFO' ])
  },
  watch: {
    getPaymentType: {
      handler(newVal, oldVal) {
        if (this.getStore.features.membershipPayNoRewards && newVal.length && newVal[0] === 'membership') {
          this.optOutRewards = true;
        }
        if (this.getStore.features.membershipPayNoRewards && oldVal.length && oldVal[0] === 'membership' && newVal.length && newVal[0] !== 'membership' )
          this.optOutRewards = false;
      },
      immediate: true
    }
  },

  mounted() {
    this.$nextTick(() => {
      const payWithMembership = this.getPaymentType && this.getPaymentType.length && this.getPaymentType[0] === 'membership'
      if (this.getStore.features.membershipPayNoRewards && payWithMembership) {
        this.optOutRewards = true
        return
      }
      // We default to giving them rewards aka not opting out
      // Normally this flag is left out unless the store wants us to ask
      if (this.shouldAsk && !('optOutRewards' in this.getCheckoutInfo))
        this.optOutRewards = false
    })
  }
}
</script>

<style>
  #OptinRewards .v-input--radio-group__input {
    display: block;
  }
  #OptinRewards .v-radio.theme--light {
    display: inline-block;
  }
  #OptinRewards .v-radio .v-label {
    display: inline-block;
    top: -6px;
  }
</style>
<style scoped>
  #OptinRewards {
    max-width: 780px;
    margin: 40px 16px 0px;

    text-align: left;
  }

  #OptinRewards .layout {
    margin-top: 10px;
  }
</style>